import { render, staticRenderFns } from "./NewEmails.vue?vue&type=template&id=6923ddb0&"
import script from "./NewEmails.vue?vue&type=script&lang=js&"
export * from "./NewEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports